import { AnyAction } from 'redux'

import { UserInterface } from 'src/types/UserInterface'
import { SHARE_DASHBOARD_USERS_CHANGED } from '../constants/constants'

export const shareDashboardUsersSetUsersDispatcher = (users: UserInterface[]): AnyAction => ({
  type: SHARE_DASHBOARD_USERS_CHANGED,
  payload: { users },
})
